import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import { useForm, Controller } from 'react-hook-form';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import {
  TextField,
  FormControlLabel,
  Select,
  FormControl,
  MenuItem,
  InputLabel,
  Button,
  FormHelperText,
} from '@material-ui/core';

import cls from './formSend.module.scss';

import Spinner from '../../../components/Spinner';
import AnalyticsHelper from '../../../helpers/AnalyticsHelper';
import PhoneInput from '../../../components/PhoneInput';

function FormSend({ startPoint, contact, setFormModal }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const locale = useSelector((state) => state.locale);
  const user = useSelector((state) => state.authentication.user);
  const [lvlTeam, setLvlTeam] = useState([]);
  const [lvlActive, setLvlActive] = useState([]);
  const [isRequired, setIsRequired] = useState(false);
  const defaultValues = {};
  if (user && user.name) {
    defaultValues.firstName = String(
      user.name.first.native[Object.keys(user.name.first.native)[0]],
    );
    defaultValues.email = user.email;
  }

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
  } = useForm({
    defaultValues,
  });
  useEffect(() => {
    const lvlTeamType = ['no', 'occasionally', 'often'];
    const lvlActivity = ['low', 'middle', 'high', 'veryHigh', 'extreme'];
    const newLvlTeamType = lvlTeamType.map((el) => ({
      value: el,
      label: t(`popup.auth.select.${el}`),
    }));
    const newLvlActivity = lvlActivity.map((el) => ({
      value: el,
      label: t(`create.step2.element.${el}`),
    }));
    setLvlTeam(newLvlTeamType);
    setLvlActive(newLvlActivity);
  }, [locale, t, startPoint, contact]);
  const onSubmit = (values) => {
    setIsRequired(true);
    if (startPoint) {
      AnalyticsHelper.sendStaticEvent('findMeATeamSubmit');
    } else {
      AnalyticsHelper.sendStaticEvent('findMeAEventSubmit');
    }
    return dispatch((data, getState, { api }) => {
      api({
        method: 'PUT',
        url: `/Booking/helpOffer`,
        data: values,
      })
        .then((result) => {
          setFormModal(false);
          setIsRequired(false);
          const { email } = result.data;
          if ((!user || !user.slug) && typeof window !== 'undefined') {
            // eslint-disable-next-line no-underscore-dangle
            const _hsq = (window._hsq = window._hsq || []);
            _hsq.push([
              'identify',
              {
                email,
              },
            ]);
            _hsq.push(['trackPageView']);
          }

          return toast(t('popup.company'), {
            type: toast.TYPE.SUCCESS,
          });
        })
        .catch(() =>
          toast(t('validate.validateForm'), { type: toast.TYPE.ERROR }),
        );
    });
  };

  const onSubmitForm = (e) => handleSubmit((data) => onSubmit(data))(e);
  return (
    <div className={cls.paycards_wrapper}>
      <Spinner show={isRequired} />
      <form onSubmit={onSubmitForm} className={cls.pay_form}>
        <div className={cls.form_line}>
          <div className={cls.form_line_item}>
            <TextField
              error={Boolean(errors.firstName)}
              fullWidth
              autoComplete="off"
              variant="outlined"
              label={t('purchase.name')}
              name="firstName"
              {...register('firstName', {
                required: t('form.validate.required'),
              })}
              helperText={errors.firstName ? errors.firstName.message : ''}
            />
          </div>
        </div>
        <div className={cls.form_line}>
          <div className={cls.form_line_item_phone}>
            <PhoneInput
              t={t}
              value={String(user.phone)}
              error={Boolean(errors.phone)}
              register={register}
              defaultCountry="cy"
              name="phone"
              label={t('purchase.phone')}
              helperText={errors.phone ? errors.phone.message : ''}
              fullWidth
              autoComplete="off"
              variant="outlined"
            />
          </div>
        </div>
        <div className={cls.form_line}>
          <div className={cls.form_line_item}>
            <TextField
              error={Boolean(errors.email)}
              fullWidth
              autoComplete="off"
              variant="outlined"
              label={t('purchase.email')}
              placeholder={t('purchase.formEmail')}
              name="email"
              {...register('email', {
                required: t('form.validate.required'),
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                  message: t('form.validate.eMailInvalid'),
                },
              })}
              helperText={errors.email ? errors.email.message : ''}
            />
          </div>
        </div>
        <div className={cls.form_line}>
          <div className={cls.form_line_item}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel>{t('popup.auth.select.title')}</InputLabel>
              <Controller
                error={Boolean(errors.experience)}
                render={({ field }) => (
                  <Select {...field}>
                    {lvlTeam.map((el, key) => (
                      <MenuItem value={el.value} button key={key}>
                        {el.label}
                      </MenuItem>
                    ))}
                  </Select>
                )}
                label={t('popup.auth.select.title')}
                name="experience"
                control={control}
                placeholder={t('popup.auth.select.title')}
                className={cls.selector}
              />
            </FormControl>
          </div>
        </div>
        {startPoint && (
          <div className={cls.form_line}>
            <div className={cls.form_line_item}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel> {t('create.step2.block.lvlActivity')}</InputLabel>
                <Controller
                  error={Boolean(errors.lvlActivity)}
                  render={({ field }) => (
                    <Select {...field}>
                      {lvlActive.map((el, key) => (
                        <MenuItem value={el.value} button key={key}>
                          {el.label}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                  className={cls.selector}
                  placeholder={t('create.step2.block.lvlActivity')}
                  name="lvlActivity"
                  control={control}
                />
                <FormHelperText>
                  {errors.lvlActivity ? errors.lvlActivity.message : ''}
                </FormHelperText>
              </FormControl>
            </div>
          </div>
        )}
        {contact && (
          <div className={cls.form_line}>
            <div className={`${cls.form_line_item} ${cls.form_line_area}`}>
              <TextField
                error={Boolean(errors.askUser)}
                fullWidth
                autoComplete="off"
                variant="outlined"
                label={t('purchase.askUser')}
                placeholder={t('purchase.askUser')}
                name="askUser"
                {...register('askUser', {
                  required: t('form.validate.required'),
                })}
                helperText={errors.askUser ? errors.askUser.message : ''}
              />
            </div>
          </div>
        )}
        {contact && (
          <div className={cls.contact_description}>
            <p>{t('purchase.contact_desc')}</p>
          </div>
        )}
        <div className={cls.isRead}>
          <FormControlLabel
            error={Boolean(errors.read)}
            control={
              <input
                name="read"
                type="checkbox"
                value="yes"
                {...register('read', { required: t('form.validate.required') })}
              />
            }
            label={
              <p className={cls.isRead_label}>
                {t('popup.register.read')}
                <a href="/lp/terms" target="_blank">
                  {t('popup.register.terms')}
                </a>
              </p>
            }
          />
          <FormHelperText style={{ color: 'red' }}>
            {errors.read ? errors.read.message : ''}
          </FormHelperText>
        </div>
        <div className={cls.vertical_group}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            size="large"
            className={cls.next_btn}
          >
            {contact
              ? t('purchase.contact')
              : t('event.eventAction.addHelpTitle')}
          </Button>
        </div>
        <Button startIcon={<WhatsAppIcon />} className={cls.WhatsApp}>
          <a
            href="https://wa.me/436764752656"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('event.eventAction.writeWhatsAppResult')}
          </a>
        </Button>
      </form>
    </div>
  );
}

FormSend.propTypes = {
  setFormModal: PropTypes.func,
  startPoint: PropTypes.string,
  contact: PropTypes.shape({
    event: PropTypes.string,
    yacht: PropTypes.string,
    user: PropTypes.string,
  }),
};
FormSend.defaultProps = {
  startPoint: '',
  contact: null,
  setFormModal: () => {},
};

export default FormSend;
